import { Component, Input, ViewEncapsulation, Output, EventEmitter, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { Ticker } from 'app/interfaces/ticker';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'app/auth/service';
@Component({
  selector: 'paginated-table',
  templateUrl: './paginated-table.component.html',
  styleUrls: ['./paginated-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaginatedTableComponent implements OnInit{
  
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  public ColumnMode = ColumnMode.force;
  public SelectionType = SelectionType.single;
  
  @Input('search') search: FormControl = null;
  @Input('rows') rows: BehaviorSubject<Ticker[]>;
  @Input('type') public type: 'stock' | 'crypto';
  @Input('count') public count: number;
  @Input('limit') public limit: number;
  @Input('page') public page: number;
  @Output() rowSelect = new EventEmitter();
  @Output() showDetails = new EventEmitter();
  @Output() changePage = new EventEmitter();
  public tickers_data: Ticker[] = [];
  constructor(private authService: AuthenticationService) { 
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.rows.pipe(takeUntil(this._unsubscribeAll)).subscribe((tickers: Ticker[])=>{
      this.tickers_data = tickers;
    });
  }

  onSelect($event){
    this.rowSelect.emit($event.selected[0]);
  }

  ViewDetail(row){
    this.showDetails.emit(row);
  }

  pageChange(event){
    this.changePage.emit(event.page);
  }

  get status(){
    if(this.authService.currentUserValue){
      return 'N/A';
    } else {
      if(this.page == 1){
        return 'N/A';
      } else {
        return 'Premium';
      }
    }
  }

}
